import React, { FC } from 'react'

import { IconBraceletDisabledProps } from './IconBraceletDisabled.types'
import * as Styled from './styles/IconBraceletDisabled.style'

import { nonThemeableRules } from '../../ruleSet'

const IconBraceletDisabled: FC<IconBraceletDisabledProps> = ({
  size = nonThemeableRules.defaultSize as number as IconBraceletDisabledProps['size'],
  isResponsive = false,
}: IconBraceletDisabledProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M12.995 24.527a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M12.995 24.527a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M12.995 24.13a.102.102 0 1 0 0-.205.102.102 0 0 0 0 .205Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M12.995 24.13a.102.102 0 1 0 0-.205.102.102 0 0 0 0 .205Z'
          stroke='#E60000'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M27.043 9.08h-2.085a7.988 7.988 0 0 0-7.988 7.987v13.985a7.988 7.988 0 0 0 7.988 7.988h2.085a7.988 7.988 0 0 0 7.987-7.988V17.067a7.988 7.988 0 0 0-7.988-7.987Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path
          d='M26.442 43h-1.427A16 16 0 0 1 9 27.025v0-6A16 16 0 0 1 25 5.05h1.433A12.478 12.478 0 0 1 38.955 17.5v13.012A12.48 12.48 0 0 1 26.475 43h-.033Zm8.641-18.942h3.872'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeMiterlimit='10'
          strokeWidth='2'
        />
        <path d='M42 6 6 42' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconBraceletDisabled
